import { orderApi } from '@formosa/shared/api/order';

/** 訂單頁主分類：限時 / 交割 / 永續 */
export const ORDER_PLAY_TABS = [
  { key: 'timed', labelKey: 'orders.tabTimed' },
  { key: 'futures', labelKey: 'orders.tabFutures' },
  { key: 'perpetual', labelKey: 'orders.tabPerpetual' },
];

/** 各主分類下的子分頁與查詢參數 */
export const ORDER_SUB_TABS = {
  timed: [
    {
      key: 'positions',
      labelKey: 'orders.positions',
      listType: 'timedActive',
      query: { status: 'START,PROCESS' },
    },
    {
      key: 'history',
      labelKey: 'orders.history',
      listType: 'timedHistory',
      query: { status: 'END,FAIL' },
    },
  ],
  futures: [
    {
      key: 'positions',
      labelKey: 'orders.positions',
      listType: 'futuresActive',
      query: { state: 'BOOKED' },
    },
    {
      key: 'history',
      labelKey: 'orders.history',
      listType: 'futuresHistory',
      query: { state: 'SETTLED,CANCELLED' },
    },
  ],
  perpetual: [
    {
      key: 'pending',
      labelKey: 'orders.pending',
      listType: 'perpetualPending',
      query: { status: 'PENDING' },
    },
    {
      key: 'open',
      labelKey: 'orders.open',
      listType: 'perpetualOpen',
      query: { status: 'OPEN' },
    },
    {
      key: 'entrustHistory',
      labelKey: 'orders.entrustHistory',
      listType: 'perpetualEntrustHistory',
      query: { status: 'CANCELLED' },
    },
    {
      key: 'positionHistory',
      labelKey: 'orders.positionHistory',
      listType: 'perpetualPositionHistory',
      query: { status: 'CLOSED,LIQUIDATED' },
    },
  ],
};

export function getDefaultSubTab(playTab) {
  return ORDER_SUB_TABS[playTab]?.[0]?.key || 'positions';
}

export function resolveSubTab(playTab, subTabKey) {
  const tabs = ORDER_SUB_TABS[playTab] || [];
  return tabs.find((tab) => tab.key === subTabKey) || tabs[0];
}

export async function fetchOrderPage(playTab, subTabKey, pageNo, pageSize = 15) {
  const subTab = resolveSubTab(playTab, subTabKey);
  if (!subTab) {
    return { records: [], current: pageNo, pages: 1 };
  }

  const params = { pageNo, pageSize, ...subTab.query };

  if (playTab === 'timed') {
    return orderApi.listTimedOrders(params);
  }
  if (playTab === 'futures') {
    return orderApi.listFuturesOrders(params);
  }
  return orderApi.listPerpetualOrders(params);
}

export function buildProductMap(products) {
  const map = new Map();
  (products || []).forEach((product) => {
    if (product?.id != null) {
      map.set(product.id, product);
    }
  });
  return map;
}

export function resolveOrderProduct(order, playTab, productMaps) {
  if (!order?.productId) {
    return null;
  }
  return productMaps[playTab]?.get(order.productId) || null;
}
